/**
 * encodes given object to a url string
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function encodeData(data: any): string {
    const props: string[] = [];
    for (const key in data) {
        if (
            Object.prototype.hasOwnProperty.call(data, key) &&
            data[key] !== undefined &&
            data[key] !== null
        ) {
            props.push([key, data[key]].map(encodeURIComponent).join('='));
        }
    }
    return props.join('&');
}

export function getQueryParameters<T>(url: string): T {
    const parameters = {};

    if (url === '') {
        return <T>{};
    }

    url.split('&').forEach((param: string) => {
        if (param === '') {
            return;
        }

        const separatorIndex = param.indexOf('=');
        const key =
            separatorIndex === -1 ? param : param.substring(0, separatorIndex);
        const value =
            separatorIndex === -1 ? key : param.substring(separatorIndex + 1);

        (<{ [i: string]: string }>parameters)[safeDecodeURIComponent(key)] =
            safeDecodeURIComponent(value);
    });

    return <T>parameters;
}

export function getParameterByName(url: string, name: string): string | null {
    // courtesy of
    // http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
    name = name.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);

    if (!results) {
        return null;
    }

    if (!results[2]) {
        return null;
    }

    return safeDecodeURIComponent(results[2].replace(/\+/g, ' '));
}

function safeDecodeURIComponent(value: string): string {
    try {
        return decodeURIComponent(value);
    } catch {
        return value;
    }
}

export function isSameOrigin(url: string): boolean {
    try {
        return (
            new URL(url, window.location.href).origin === window.location.origin
        );
    } catch {
        return false;
    }
}
